module.exports = __webpack_public_path__ + "static/media/dashboard.59c68950.png";